"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reverseRichText = exports.richTextFormatToData = exports.toEntityType = exports.parseDisplayName = exports.parseId = exports.parsePath = exports.mentionsRegx = exports.formatLink = void 0;
const enums_1 = require("../enums");
/**
 * Supported link paths.
 *
 * Each path must be included in mentionAdaptor.
 */
var IntegrationLinkPaths;
(function (IntegrationLinkPaths) {
    IntegrationLinkPaths["CLUB"] = "club";
    IntegrationLinkPaths["USER"] = "user";
    IntegrationLinkPaths["EVENT"] = "event";
})(IntegrationLinkPaths || (IntegrationLinkPaths = {}));
const protocol = "tonit";
const mentionAdaptor = {
    ["event" /* EVENT */]: {
        link: {
            path: "event" /* EVENT */,
            displayNameField: "title",
            idField: "id",
        },
        entity: {
            idField: "id",
            slugField: "title",
            type: enums_1.DomainObjects.Event,
        },
    },
    ["user" /* USER */]: {
        link: {
            path: "user" /* USER */,
            displayNameField: "username",
            idField: "id",
        },
        entity: {
            idField: "_id",
            slugField: "username",
            type: enums_1.DomainObjects.Profile,
        },
    },
    ["club" /* CLUB */]: {
        entity: {
            type: enums_1.DomainObjects.Club,
            idField: "_id",
            slugField: "name",
        },
        link: {
            path: "club" /* CLUB */,
            idField: "id",
            displayNameField: "name",
        },
    },
};
const formatLink = (type, data) => {
    const adaptor = mentionAdaptor[type];
    if (!adaptor) {
        // No mention adaptor available for "${type}"! Cannot create this mention
        return null;
    }
    const params = requiredParamAccessor(adaptor)(data);
    return `${protocol}://${type}?${toUriParamList(uriSafeParamFormatter, params)}`;
};
exports.formatLink = formatLink;
/**
 * Turn an object into URI params
 */
const toUriParamList = (entryFormatter, dictionary) => {
    return Object.entries(dictionary).map(entryFormatter).join("&");
};
/**
 * Create a single encoded URI param key value pair
 */
const uriSafeParamFormatter = ([key, value]) => {
    return `${key}=${encodeURIComponent(value)}`;
};
/**
 * Pre-made accessor which can create id and display name params from an entity.
 */
const requiredParamAccessor = (adaptor) => entityAccessor([
    [adaptor.link.idField, adaptor.entity.idField],
    [adaptor.link.displayNameField, adaptor.entity.slugField],
]);
const entityAccessor = (keys) => (data) => {
    return keys.reduce((map, [key, keyAccessor]) => {
        const value = data[keyAccessor];
        if (!value) {
            // Tried to access the field "${keyAccessor}" but found nothing!
            return map;
        }
        return Object.assign(Object.assign({}, map), { [key]: value });
    }, {});
};
/** Eg, id, _ids, etc */
const possibleLinkIdFields = Object.values(mentionAdaptor).map((m) => m.link.idField);
/** Eg, name, username, title, etc */
const possibleLinkDisplayNameFields = Object.values(mentionAdaptor).map((m) => m.link.displayNameField);
// TODO: a param with a > character will totally break this match
exports.mentionsRegx = new RegExp(`(<@${protocol}\:\/\/[A-z]+\?.*?>)`, "g");
const parsePath = (mention) => {
    const path = mention.match(new RegExp(`<@${protocol}\\:\\/\\/(${Object.keys(mentionAdaptor).join("|")}){1}?\\?`));
    return (path === null || path === void 0 ? void 0 : path.length) >= 1 ? decodeURIComponent(path[1]) : null;
};
exports.parsePath = parsePath;
const paramParser = (possibleParamKeys) => (mention) => {
    const matches = mention.match(new RegExp(`(?:${possibleParamKeys.join("|")})=(.+?)[>&]{1}`));
    return (matches === null || matches === void 0 ? void 0 : matches.length) >= 1 ? decodeURIComponent(matches[1]) : null;
};
exports.parseId = paramParser(possibleLinkIdFields);
exports.parseDisplayName = paramParser(possibleLinkDisplayNameFields);
const toEntityType = (mention) => {
    var _a;
    const proto = exports.parsePath(mention);
    return (_a = mentionAdaptor[proto]) === null || _a === void 0 ? void 0 : _a.entity.type;
};
exports.toEntityType = toEntityType;
const richTextFormatToData = (rich) => {
    try {
        return { id: exports.parseId(rich), displayName: exports.parseDisplayName(rich) };
    }
    catch (error) {
        // Could not parse an id and username from this mention rich text: ${rich}
        return {};
    }
};
exports.richTextFormatToData = richTextFormatToData;
/**
 * Takes rich text and transforms it into what the mentions
 * object would have been.
 * Usually this goes the other way but there may be some cases
 * where we want to rebuild the mentions from the rich text.
 * Eg, while editing a post.
 */
const reverseRichText = (richText) => {
    if (!richText)
        return richText;
    const tokens = richText.split(exports.mentionsRegx);
    return tokens
        .map((token) => {
        // i includes the null
        if (token.match(exports.mentionsRegx)) {
            const { displayName } = exports.richTextFormatToData(token);
            return `@${displayName}`;
        }
        return token;
    })
        .join("");
};
exports.reverseRichText = reverseRichText;
